import React, {useContext} from 'react';
import {StyleSheet, View} from 'react-native';
import {theme} from "@common/theme/theme";
import {IconButton} from "react-native-paper";
import TextM from "@common/components/text/TextM";
import {DimensionsContext} from "@common/utils/mobileUtils";

const StartingFormHeader = ({
                                step, totalSteps, title, stepTitle, onClose = () => {
    }
                            }) => {
    const dimensions = useContext(DimensionsContext)
    const progressPercentage = (step / totalSteps) * 100;
    return (
        <View style={{
            // paddingHorizontal: 16,
            marginBottom: 30,
            width: dimensions.width,
            alignSelf: "center",
        }}>
            <View style={styles.headerContainer}>
                <IconButton
                    icon={"times"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{}}
                    onPress={onClose}
                />
                <View style={styles.titleContainer}>
                    <TextM color={theme.colors.primary} fontSize={22} fontWeight={"ExtraBold"}>
                        {title}
                    </TextM>
                    <TextM fontSize={13} fontWeight={"Bold"}>
                        Étape {step} / {totalSteps} <TextM>- {stepTitle}</TextM>
                    </TextM>
                </View>

            </View>

            <View style={styles.progressBarContainer}>
                <View
                    style={[
                        styles.progressBar,
                        {width: `${progressPercentage}%`},
                    ]}
                />
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 12,
    },
    closeButton: {},
    titleContainer: {
        flex: 1,
    },
    titleText: {
        fontSize: 22,
        fontWeight: 'ExtraBold',
        color: theme.colors.primary,
        textAlign: 'center'

    },
    subtitleText: {
        fontSize: 13,
        color: theme.colors.grey,
        opacity: 0.8,
        textAlign: 'center'

    },
    progressBarContainer: {
        height: 6,
        backgroundColor: theme.colors.lighter,
        borderRadius: 2,
        width: '100%',
    },
    progressBar: {
        height: '100%',
        backgroundColor: theme.colors.success,
    },
});

export default StartingFormHeader;
